var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.3 18.9",
    style: {
      enableBackground: "new 0 0 20.3 18.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,12.7c-1.5,0-2.8-1.2-2.8-2.8c0-1.5,1.2-2.8,2.8-2.8h5.3v5.5C18.9,12.7,13.6,12.7,13.6,12.7z M13.5,9.3 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7C14.2,9.6,13.9,9.3,13.5,9.3z M17.2,1.4h-14 c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h14c0.9,0,1.7,1.9,1.7,2.8v0.2h-5.3c-2.3,0-4.1,1.8-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1h5.3v0.2 c0,0.9-0.8,1.7-1.7,1.7h-14c-0.9,0-1.7-0.8-1.7-1.7V4.4c0-0.4-0.3-0.7-0.7-0.7C0.5,3.7,0.2,4,0.2,4.4v9.8c0,1.7,1.4,3,3,3h14 c1.7,0,3-1.4,3-3V5.6C20.2,3.9,18.9,1.4,17.2,1.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.dcad16be9002a734e7ecc3283913c5a9.svg";
export { ForwardRef as ReactComponent };